export const ChatBubbleSparklesSvg = () => {
  return (
    <svg
      width="120"
      height="110"
      viewBox="0 0 120 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Alone sfumato dietro la bolla */}
      <circle cx="60" cy="55" r="44" fill="var(--primary-500)" opacity="0.12" />
      <circle cx="60" cy="55" r="32" fill="var(--primary-500)" opacity="0.10" />

      {/* Bolla chat */}
      <rect x="26" y="30" width="68" height="46" rx="16" fill="var(--primary-500)" />
      {/* Coda della bolla */}
      <path d="M44 74 L38 86 L56 76 Z" fill="var(--primary-500)" />

      {/* Occhi */}
      <circle cx="48" cy="49" r="4" fill="white" />
      <circle cx="72" cy="49" r="4" fill="white" />
      {/* Sorriso */}
      <path d="M50 60 Q60 68 70 60" stroke="white" strokeWidth="3" strokeLinecap="round" fill="none" />

      {/* Sparkles */}
      <path
        className="sparkle-pulse"
        d="M97 22 L99.5 28.5 L106 31 L99.5 33.5 L97 40 L94.5 33.5 L88 31 L94.5 28.5 Z"
        fill="var(--primary-400, var(--primary-500))"
      />
      <path
        className="sparkle-pulse sparkle-pulse--delayed"
        d="M22 14 L23.8 18.7 L28.5 20.5 L23.8 22.3 L22 27 L20.2 22.3 L15.5 20.5 L20.2 18.7 Z"
        fill="var(--primary-300, var(--primary-500))"
      />
      <path
        className="sparkle-pulse sparkle-pulse--delayed-2"
        d="M104 60 L105.4 63.6 L109 65 L105.4 66.4 L104 70 L102.6 66.4 L99 65 L102.6 63.6 Z"
        fill="var(--primary-300, var(--primary-500))"
      />
    </svg>
  )
}
